// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-width .form-group{width:100%}.input-width{display:flex;align-items:center}`, "",{"version":3,"sources":["webpack://./resources/app/modules/course/CourseBuilder/Blocks/ProcessBlock/index.scss"],"names":[],"mappings":"AAAA,yBACE,UAAA,CAGF,aACE,YAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
